export const REQUIRED_MESSAGE = 'validation.required';
export const INVALID_DATA_MESSAGE = 'validation.invalidData';
